/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    // 获取合同列表
    GetContractListShow({ commit }, data) {
        return axios.post(http + '/org/contract/show_other', data).then(res => {
            return res.data
        })
    },
    SaveContract({ commit }, data) {
        return axios.post(http + '/org/contract/add', data).then(res => {
            return res.data
        })
    },
    DeleteContract({ commit }, data) {
        return axios.post(http + '/org/contract/delete', data).then(res => {
            return res.data
        })
    },
    GetContractOcenterListShow({ commit }, data) {
        return axios.post(http + '/org/contract/show_oc', data).then(res => {
            return res.data
        })
    }
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const ContractManagementModule = {
    state,
    getters,
    actions,
    mutations
}
export default ContractManagementModule
